// LogRocket browser/network URL callbacks are separate from Phoenix's param
// filters. Strip Search query/fragment without changing real navigation URLs.
export function sanitizeSearchURL(url) {
  try {
    const path = decodeURIComponent(
      new URL(url, "https://enaia.invalid").pathname,
    )
    // Match SearchNavigation's legacy aliases and canonical acc_/del_ UIDs.
    // UID payloads are 22 Base64url characters; the final padding bits are zero.
    const match = path.match(
      /^\/search(?:\/account\/(?:[A-Za-z0-9]{1,64}|acc_[A-Za-z0-9_-]{21}[AQgw])|\/deal\/(?:[A-Za-z0-9]{1,64}|del_[A-Za-z0-9_-]{21}[AQgw]))?$/,
    )
    if (match?.[0] === path) {
      return url.split(/[?#]/, 1)[0]
    }
  } catch {
    // Preserve unrelated invalid SDK input; the router rejects malformed URLs.
  }
  return url
}

export const searchPrivacy = {
  browser: { urlSanitizer: sanitizeSearchURL },
  network: {
    requestSanitizer: (request) => ({
      ...request,
      url: sanitizeSearchURL(request.url),
    }),
  },
}
